

<template>



<div class="boxDetai"   ref="detail">
<!--        <i class="el-icon-error" @click="close"  style="font-size: 30px;color:red;position: absolute;right:0;top:0;"></i>-->
  <div class="detaiBox" style="width: 100%;height:100%;overflow: auto;">
<!--    <div class="buttonBox" style="justify-content: flex-end;font-size: 30px;box-sizing: border-box">-->
<!--      <span>游戏详情</span>-->
<!--    </div>-->
    <div class="name" style="text-align: left;min-height: 80px;">
      <div class="title">游戏名称</div>
      <span class="textCon">{{rowMy['name']}}</span>
    </div>
  <div class="name" style="text-align: left;min-height: 150px;">
    <div class="title">游戏描述</div>
    <span class="textCon">{{rowMy['description']}}</span>
  </div>
  <div class="name" style="text-align: left;">
    <div class="title">下载链接(如果是电脑vr串流,下载解压游戏前要关闭所有杀毒软件)</div>
    <div v-if="isVip" style="display: flex;justify-content: center;align-items: center;min-height: 150px;">
      <span class="textCon" @click.stop="" target="_blank" :href="rowMy['link']">{{rowMy['link']}}</span>
<!--      <span class="textCon">提取码:{{row['code']}}</span>-->
    </div>
   <div class="" v-if="!isVip" style="display: flex;justify-content: center;align-items: center;min-height: 150px;">
     请办理会员之后查看
   </div>
  </div>
  <div class="name" style="text-align: left;">
    <div class="title">游戏图片</div>
    <div class="imgCon" style="display: flex;">
      <img :src="baseUrl+img" alt="" v-for="img in rowMy['imgs'].split(',')" style="object-fit: cover; width: 100%; margin:7px 0.5% 0px 0.5%;display: block;margin-top: 7px;">
    </div>
  </div>
  <div class="linkCode">
    <span>
      <a href=""></a>
    </span>
  </div>
  </div>
</div>

</template>
<script>
import {getUserInfo,getGameDetail} from "@/api/qt/common"
  export default {
    props:['row'],
    data(){
      return {
        baseUrl:"",
        userInfo:{},
        gameInfo:{},
        rowMy:{}
        // row:{}
      };
    },
    created() {
      this.baseUrl=this.$baseUrl;
      // console.log(this.row,"传过来的")
      this.getUserInfoMy();
      this.getMyInfo();
    },
    mounted() {

    },
    computed:{
      isVip(){
        if(!this.userInfo){
          return false;
        }
        return new Date(this.userInfo.end_time*1000).getTime()>new Date().getTime();
      }
    },
    methods:{
      getMyInfo(){
        getUserInfo(localStorage.getItem("token")).then((res)=>{

          let userInfo = res.data.data;
          this.userInfo = userInfo;
        })
      },
      getGameInfo(){

        getGameDetail(this.row.id).then((res)=>{
          console.log(res.data,'123456')

          this.rowMy=res.data.data
        })
      },
      getUserInfoMy(){
        this.getGameInfo();
      },
      close(){
        this.$emit("setGameInfoShow",false)
      }
    }
  }
</script>
<style scoped>
.boxDetai{
  width:80%;
  margin: auto;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;


}
.boxDetai::-webkit-scrollbar-thumb{
  width: 5px;
}
.title{
  background-color: rgba(44,62,80,0.7);
  line-height: 30px;
  font-size: 16px;
  text-align: left;
  padding-left: 3px;
  color:#fff;
  box-sizing: border-box;
}
.name{
  margin-top: 18px;
}
.textCon{
  padding-left: 15px;
  box-sizing: border-box;
  line-height: 20px;
  margin-top: 15px;
  display: block;
}
/* 针对 WebKit 引擎的浏览器（如 Chrome 和 Safari） */
::-webkit-scrollbar {
  display: none;
  width: 10px; /* 滚动条的宽度 */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: white; /* 滚动条背景颜色 */
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: #eee; /* 滑块颜色 */
  border-radius: 10px; /* 可以添加圆角 */
}

/* 滚动条滑块在点击拖动时（可选）*/
::-webkit-scrollbar-thumb:active {
  background: darkgreen; /* 滑块在拖动时的颜色 */
}

/* 如果需要为滚动条添加过渡效果（可选）*/
::-webkit-scrollbar-thumb {
  transition: background 0.3s ease;
}

/* 应用滚动条样式的元素 */
.scrollable-element {
  /* 设置 overflow 属性以显示滚动条 */
  overflow-y: auto; /* 或者 overflow-x: auto; 如果你需要水平滚动条 */
  height: 200px; /* 或者 width: 200px; 取决于你的需求 */
}
</style>
